/* Vestiganga Mayorista — ficha de producto y calculadora (usa helpers de vg-mayorista.js) */
(function () {
  'use strict';
  function boot() {
    var VG = window.VG; if (!VG) return;
    var $ = VG.$, $$ = VG.$$, toast = VG.toast, formatMoney = VG.formatMoney, refreshCartCount = VG.refreshCartCount;
  /* ---------- Product ---------- */
  function initProduct(root) {
    if (root.dataset.bound) return; root.dataset.bound = '1';
    var dataEl = $('[data-vg-product-json]', root); if (!dataEl) return;
    var P = JSON.parse(dataEl.textContent);
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };

    /* Gallery */
    var gal = $('[data-vg-gal]', root), thumbs = $$('[data-vg-thumb]', root), cnt = $('[data-vg-gal-count]', root);
    var slides = gal ? $$('.vg-gal__slide', gal) : [];
    function goSlide(i) { if (!gal || !slides[i]) return; gal.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { goSlide(Number(b.dataset.vgThumb)); }); });
    if (gal) {
      var onScroll = function () {
        var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (cnt) cnt.textContent = (i + 1) + ' / ' + slides.length;
      };
      gal.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
    }
    function showMedia(id) { if (!id) return; for (var i = 0; i < slides.length; i++) { if (Number(slides[i].dataset.mediaId) === id) { goSlide(i); return; } } }

    var buy = $('[data-vg-buy]', root);
    if (!buy) return;
    buy.hidden = false;

    var qty = {}; /* variantId -> cantidad */
    var optInputs = $$('[data-vg-opt]', root);
    var nOpts = P.variants.length ? P.variants[0].options.length : 0;

    function selected() {
      var sel = [];
      for (var i = 0; i < nOpts; i++) {
        var c = optInputs.filter(function (x) { return Number(x.dataset.vgOpt) === i && x.checked; })[0];
        sel[i] = c ? c.value : null;
      }
      return sel;
    }
    function matches(v, sel, skip) {
      for (var i = 0; i < sel.length; i++) { if (i === skip) continue; if (sel[i] != null && v.options[i] !== sel[i]) return false; }
      return true;
    }
    function maxFor(v) { return (v.managed && v.deny) ? Math.max(0, v.inv) : 9999; }

    /* Disponibilidad de cada valor de opción */
    function paintOptions() {
      var sel = selected();
      optInputs.forEach(function (inp) {
        var i = Number(inp.dataset.vgOpt);
        var test = sel.slice(); test[i] = inp.value;
        var any = P.variants.some(function (v) { return v.available && matches(v, test, P.sizeIndex); });
        inp.closest('[data-vg-optval]').classList.toggle('vg-opt--na', !any);
      });
      $$('[data-vg-optlab]', root).forEach(function (l) { l.textContent = sel[Number(l.dataset.vgOptlab)] || ''; });
    }

    var curve = $('[data-vg-curve]', root);
    function sizeVariants() {
      var sel = selected();
      var seen = {}, out = [];
      P.variants.forEach(function (v) {
        var sz = v.options[P.sizeIndex];
        if (seen[sz]) return;
        if (matches(v, sel, P.sizeIndex)) { seen[sz] = 1; out.push(v); }
      });
      return out;
    }
    function drawCurve() {
      if (!curve) return;
      var list = sizeVariants();
      curve.innerHTML = list.map(function (v) {
        var sz = esc(v.options[P.sizeIndex]), q = qty[v.id] || 0, mx = maxFor(v), na = !v.available;
        var note = na ? 'Agotada' : (v.managed ? (v.inv > 0 ? v.inv + ' disp.' : 'Bajo pedido') : '');
        return '<div class="vg-curve__c' + (na ? ' vg-curve__c--na' : '') + '"><b>' + sz + '</b>' + (note ? '<small>' + note + '</small>' : '') +
          '<div class="vg-stp"><button type="button" data-vid="' + v.id + '" data-d="-1" aria-label="Menos talla ' + sz + '"' + (na || q <= 0 ? ' disabled' : '') + '>–</button>' +
          '<input type="number" inputmode="numeric" min="0" max="' + mx + '" value="' + q + '" data-vid="' + v.id + '" aria-label="Unidades talla ' + sz + '"' + (na ? ' disabled' : '') + '>' +
          '<button type="button" data-vid="' + v.id + '" data-d="1" aria-label="Más talla ' + sz + '"' + (na || q >= mx ? ' disabled' : '') + '>+</button></div></div>';
      }).join('');
    }
    function variantById(id) { id = Number(id); for (var i = 0; i < P.variants.length; i++) if (P.variants[i].id === id) return P.variants[i]; return null; }
    function setQty(id, n) {
      var v = variantById(id); if (!v || !v.available) return;
      n = Math.max(0, Math.min(maxFor(v), Math.floor(Number(n) || 0)));
      if (n) qty[v.id] = n; else delete qty[v.id];
    }
    if (curve) {
      curve.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-vid]'); if (!b) return;
        setQty(b.dataset.vid, (qty[b.dataset.vid] || 0) + Number(b.dataset.d)); drawCurve(); summary();
      });
      curve.addEventListener('change', function (e) {
        var i = e.target.closest('input[data-vid]'); if (!i) return;
        setQty(i.dataset.vid, i.value); drawCurve(); summary();
      });
    }

    /* Productos sin talla: una cantidad para la variante elegida */
    var qinput = $('[data-vg-qinput]', root);
    function currentVariant() {
      var sel = selected();
      return P.variants.filter(function (v) { return matches(v, sel, -1); })[0] || P.variants[0];
    }
    if (qinput) {
      var syncSingle = function (n) {
        Object.keys(qty).forEach(function (k) { delete qty[k]; });
        var v = currentVariant(); setQty(v.id, n); qinput.value = qty[v.id] || 0; summary();
      };
      $$('[data-vg-q]', root).forEach(function (b) { b.addEventListener('click', function () { syncSingle((Number(qinput.value) || 0) + Number(b.dataset.vgQ)); }); });
      qinput.addEventListener('change', function () { syncSingle(qinput.value); });
    }

    var addBtn = $('[data-vg-add]', root), addSticky = $('[data-vg-add-sticky]', root), sticky = $('[data-vg-sticky]', root);
    var wa = $('[data-vg-wa]', root), msg = $('[data-vg-msg]', root);
    var waBase = wa ? wa.href.split('?')[0] : '';

    function lines() {
      return Object.keys(qty).map(function (id) { var v = variantById(id); return { v: v, q: qty[id] }; }).filter(function (l) { return l.v; });
    }
    function summary() {
      var ls = lines(), u = 0, tot = 0;
      ls.forEach(function (l) { u += l.q; tot += l.q * l.v.price; });
      $('[data-vg-sum-u]', root).textContent = u + (u === 1 ? ' unidad' : ' unidades');
      $('[data-vg-sum-p]', root).textContent = formatMoney(tot, P.moneyFormat);
      var lab = $('[data-vg-units-lab]', root); if (lab) lab.textContent = u ? u + ' und seleccionadas' : 'Elige cuántas de cada talla';
      var m = $('[data-vg-meter]', root); if (m) m.style.width = (u ? 100 : 0) + '%';
      if (addBtn) { addBtn.disabled = u === 0; addBtn.textContent = P.addLabel + (u ? ' · ' + formatMoney(tot, P.moneyFormat) : ''); }
      if (sticky) { sticky.classList.toggle('is-on', u > 0); sticky.setAttribute('aria-hidden', u > 0 ? 'false' : 'true'); if (addSticky) addSticky.tabIndex = u > 0 ? 0 : -1; $('[data-vg-sticky-t]', root).textContent = u + ' und · ' + formatMoney(tot, P.moneyFormat); }
      if (wa) {
        var txt = 'Hola Vestiganga, quiero pedir al por mayor:\n• ' + P.ident + (P.ident !== P.title ? ' (' + P.title + ')' : '');
        if (ls.length) txt += '\n' + ls.map(function (l) { return '   - ' + l.v.options.join(' / ') + ': ' + l.q + ' und'; }).join('\n') + '\nTotal: ' + u + ' unidades';
        txt += '\n¿Me confirman disponibilidad y envío?';
        wa.href = waBase + '?text=' + encodeURIComponent(txt);
      }
    }
    function showMsg(type, html) { if (!msg) return; msg.className = 'vg-msg vg-msg--' + type; msg.innerHTML = html; msg.hidden = false; }

    function add() {
      var ls = lines(); if (!ls.length) return;
      var btns = [addBtn, addSticky].filter(Boolean);
      btns.forEach(function (b) { b.disabled = true; });
      var u = ls.reduce(function (a, l) { return a + l.q; }, 0);
      fetch(P.cartAddUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ls.map(function (l) { return { id: l.v.id, quantity: l.q }; }) })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'No se pudo agregar');
          Object.keys(qty).forEach(function (k) { delete qty[k]; });
          if (qinput) qinput.value = 0;
          drawCurve(); summary();
          showMsg('ok', 'Agregaste ' + u + (u === 1 ? ' unidad' : ' unidades') + ' a tu pedido. <a href="' + P.cartUrl + '">Ver pedido</a>');
          toast('Agregado: ' + u + ' und · <a href="' + P.cartUrl + '" style="text-decoration:underline">Ver pedido</a>');
          return refreshCartCount();
        })
        .catch(function (err) { showMsg('err', esc(err.message)); summary(); });
    }
    if (addBtn) addBtn.addEventListener('click', add);
    if (addSticky) addSticky.addEventListener('click', add);

    optInputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        paintOptions(); drawCurve();
        if (qinput) { Object.keys(qty).forEach(function (k) { delete qty[k]; }); qinput.value = 0; }
        summary();
        var v = currentVariant(); if (v && v.media) showMedia(v.media);
      });
    });

    paintOptions(); drawCurve(); summary();
  }


  /* ---------- Calculadora de ganancia (misma lógica del HTML aprobado; valores en pesos) ---------- */
  function initCalc(root) {
    if (root.dataset.bound) return; root.dataset.bound = '1';
    var el = $('[data-vg-calc-json]', root.closest('.vg-wrap') || root); if (!el) return;
    var D = JSON.parse(el.textContent); if (!D.items || !D.items.length) return;
    var g = function (k) { return $('[data-vg-g="' + k + '"]', root); };
    var money = function (n) { return '$' + Math.round(n).toLocaleString('es-CO'); };
    var r1000 = function (n) { return Math.ceil(n / 1000) * 1000; };
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };
    var title = function (it) { return 'Ref. ' + it.ref + (it.name ? ' · ' + it.name : ''); };
    var st = { i: 0, q: 1, pv: 0 };
    var sel = g('ref'), pv = g('pv');
    sel.innerHTML = D.items.map(function (it, i) { return '<option value="' + i + '">' + esc(title(it)) + (it.tipo ? ' · ' + esc(it.tipo) : '') + ' · ≈ ' + money(it.doz / 12) + ' c/u</option>'; }).join('');
    function setRef(reset) {
      var it = D.items[st.i], unit = it.doz / 12, mn = r1000(unit), mx = r1000(unit * 4);
      pv.min = mn; pv.max = mx; pv.step = 500;
      if (reset || st.pv < mn || st.pv > mx) st.pv = Math.min(mx, r1000(unit * 2.5));
      pv.value = st.pv;
      g('min').textContent = money(mn); g('max').textContent = money(mx);
      g('pick').innerHTML = (it.img ? '<img src="' + esc(it.img) + '" alt="" width="64" height="80" loading="lazy">' : '') + '<div><b>' + esc(title(it)) + '</b>' + esc(it.tipo) + '<br>' + (it.sizes ? 'Tallas: ' + esc(it.sizes) + ' · ' : '') + 'Docena ' + money(it.doz) + '</div>';
      var sug = [2, 2.5, 3].map(function (x) { return r1000(unit * x); }).filter(function (v, i, a) { return a.indexOf(v) === i && v <= mx; });
      g('chips').innerHTML = sug.map(function (v) { return '<button type="button" data-v="' + v + '">' + money(v) + '</button>'; }).join('');
      var add = g('add'); if (add) { add.hidden = !it.url; if (it.url) add.href = it.url; }
      draw();
    }
    function draw() {
      var it = D.items[st.i], cost = it.doz, sell = st.pv * 12, gain = sell - cost;
      var margin = sell ? gain / sell * 100 : 0, markup = cost ? gain / cost * 100 : 0;
      g('pvl').textContent = money(st.pv);
      g('q').textContent = st.q; g('units').textContent = (st.q * 12) + ' unidades';
      g('c1').textContent = money(cost); g('c2').textContent = money(sell);
      g('c3').textContent = (gain < 0 ? '-' : '') + money(Math.abs(gain));
      g('c4').textContent = gain >= 0
        ? ('≈ ' + money(st.pv - cost / 12) + ' por prenda · margen sobre la venta ' + Math.round(margin) + '% · ganancia sobre el costo ' + Math.round(markup) + '%')
        : 'A ese precio pierdes dinero';
      g('c5').textContent = money(cost * st.q);
      var c6 = g('c6'); c6.textContent = (gain < 0 ? '-' : '') + money(Math.abs(gain * st.q)); c6.classList.toggle('neg', gain < 0);
      $$('button', g('chips')).forEach(function (b) { b.classList.toggle('on', Number(b.dataset.v) === st.pv); });
      var msg = 'Hola Vestiganga, quiero hacer un pedido mayorista:\n• Referencia: ' + title(it) + (it.tipo ? ' (' + it.tipo + ')' : '') +
        '\n• Docenas: ' + st.q + ' (' + (st.q * 12) + ' unidades)' +
        '\n• Precio mayorista por docena: ' + money(it.doz) +
        '\n• Valor de compra según catálogo: ' + money(it.doz * st.q) +
        '\n¿Me confirman disponibilidad, tallas y costo de envío?';
      g('wa').href = 'https://wa.me/' + D.wa + '?text=' + encodeURIComponent(msg);
    }
    sel.addEventListener('change', function () { st.i = Number(sel.value); setRef(true); });
    pv.addEventListener('input', function () { st.pv = Number(pv.value); draw(); });
    g('chips').addEventListener('click', function (e) { var b = e.target.closest('button[data-v]'); if (!b) return; st.pv = Number(b.dataset.v); pv.value = st.pv; draw(); });
    g('minus').addEventListener('click', function () { st.q = Math.max(1, st.q - 1); draw(); });
    g('plus').addEventListener('click', function () { st.q = Math.min(50, st.q + 1); draw(); });
    setRef(true);
  }

  function initPCalc(box) {
    if (box.dataset.bound) return; box.dataset.bound = '1';
    var doz = Number(box.dataset.doz) || 0, inp = $('[data-vg-pcalc-pv]', box), out = $('[data-vg-pcalc-out]', box);
    var upd = function () { var gg = Number(inp.value || 0) * 12 - doz; out.textContent = (gg < 0 ? '-' : '') + '$' + Math.round(Math.abs(gg)).toLocaleString('es-CO'); };
    inp.addEventListener('input', upd); upd();
  }
    VG.initPage = function () { $$('[data-vg-pd]').forEach(initProduct); $$('[data-vg-calc]').forEach(initCalc); $$('[data-vg-pcalc]').forEach(initPCalc); };
    VG.initPage();
  }
  if (window.VG) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();